import { Action } from '@ngrx/store';
import { Notification } from 'src/app/notification/models/notification.model';
import { Update } from '@ngrx/entity';
import { QueryParamsModel } from '../../_base/crud';

export enum NotificationActionTypes {
  ToggleNotificationsPageLoading = '[Notification] Toggle Notifications Page Loading',
  ToggleNotificationActionLoading = '[Notification] Toggle Notification Action Loading',
  RequestNotificationsPage = '[Notification] Request Notifications Page',
  LoadNotificationsPage = '[Notification] Load Notifications Page',
  CancelNotificationsPage = '[Notification] Cancel Notifications Page',
  CreateNotification = '[Notification] Create Notification',
  CreateNotificationOnServer = '[Notification] Create Notification On Server',
  UpdateNotification = '[Notification] Update Notification',
  UpdateNotificationOnServer = '[Notification] Update Notification On Server',
  DeleteNotification = '[Notification] Delete Notification',
  DeleteNotificationOnServer = '[Notification] Delete Notification On Server',
  ThrowNotificationError = '[Notification] Throw Notification Error',
  ClearNotificationError = '[Notification] Clear Notification Error',
}

export class ToggleNotificationsPageLoading implements Action {
  readonly type = NotificationActionTypes.ToggleNotificationsPageLoading;

  constructor(public payload: { pageLoading: boolean }) {}
}

export class ToggleNotificationActionLoading implements Action {
  readonly type = NotificationActionTypes.ToggleNotificationActionLoading;

  constructor(public payload: { actionLoading: boolean }) {}
}

export class RequestNotificationsPage implements Action {
  readonly type = NotificationActionTypes.RequestNotificationsPage;

  constructor(public payload: { query: QueryParamsModel }) {}
}

export class LoadNotificationsPage implements Action {
  readonly type = NotificationActionTypes.LoadNotificationsPage;

  constructor(
    public payload: { notifications: Notification[]; totalCount: number; query: QueryParamsModel },
  ) {}
}

export class CancelNotificationsPage implements Action {
  readonly type = NotificationActionTypes.CancelNotificationsPage;
}

export class CreateNotification implements Action {
  readonly type = NotificationActionTypes.CreateNotification;

  constructor(public payload: { notification: Notification }) {}
}

export class CreateNotificationOnServer implements Action {
  readonly type = NotificationActionTypes.CreateNotificationOnServer;

  constructor(public payload: { notification: Notification }) {}
}

export class UpdateNotification implements Action {
  readonly type = NotificationActionTypes.UpdateNotification;

  constructor(public payload: { notification: Update<Notification> }) {}
}

export class UpdateNotificationOnServer implements Action {
  readonly type = NotificationActionTypes.UpdateNotificationOnServer;

  constructor(public payload: { notification: Notification }) {}
}

export class DeleteNotification implements Action {
  readonly type = NotificationActionTypes.DeleteNotification;

  constructor(public payload: { id: number }) {}
}

export class DeleteNotificationOnServer implements Action {
  readonly type = NotificationActionTypes.DeleteNotificationOnServer;

  constructor(public payload: { id: number }) {}
}

export class ThrowNotificationError implements Action {
  readonly type = NotificationActionTypes.ThrowNotificationError;

  constructor(public payload: { error: any }) {}
}

export class ClearNotificationError implements Action {
  readonly type = NotificationActionTypes.ClearNotificationError;
}

export type NotificationActions =
  | ToggleNotificationsPageLoading
  | ToggleNotificationActionLoading
  | RequestNotificationsPage
  | LoadNotificationsPage
  | CancelNotificationsPage
  | CreateNotification
  | CreateNotificationOnServer
  | UpdateNotification
  | UpdateNotificationOnServer
  | DeleteNotification
  | DeleteNotificationOnServer
  | ThrowNotificationError
  | ClearNotificationError;
